import React, { useEffect, useRef, useState } from 'react';
import './LazyMount.css';

const DEFAULT_ROOT_MARGIN = '240px 0px';

/**
 * Mounts children only after the placeholder nears the viewport.
 * When `enabled` is false, children mount immediately.
 */
const LazyMount = ({
    enabled = true,
    rootMargin = DEFAULT_ROOT_MARGIN,
    placeholder = null,
    children,
}) => {
    const hostRef = useRef(null);
    const [ready, setReady] = useState(!enabled);

    useEffect(() => {
        if (!enabled) {
            setReady(true);
            return undefined;
        }
        setReady(false);
        const el = hostRef.current;
        if (!el || typeof IntersectionObserver === 'undefined') {
            setReady(true);
            return undefined;
        }
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) {
                    setReady(true);
                    observer.disconnect();
                }
            },
            { rootMargin }
        );
        observer.observe(el);
        return () => observer.disconnect();
    }, [enabled, rootMargin]);

    return (
        <div ref={hostRef} className="lazy-mount">
            {ready ? children : placeholder}
        </div>
    );
};

export default LazyMount;
